import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import GuestHistoryAudit from '../GuestHistoryAudit';
import UpdatePayment from '../UpdatePayment';

const GuestHistoryActionsRenderer = ({ item, onUpdateSuccess }) => {
  return (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Grid item>
        <GuestHistoryAudit item={item} />
      </Grid>
      <Grid item>
        <UpdatePayment
          id={item.id}
          transaction={item}
          onUpdateSuccess={onUpdateSuccess}
        />
      </Grid>
    </Grid>
  );
};

GuestHistoryActionsRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  onUpdateSuccess: PropTypes.func,
};

GuestHistoryActionsRenderer.defaultProps = {
  onUpdateSuccess: undefined,
};

export default GuestHistoryActionsRenderer;
